import DateFnsUtils from '@date-io/date-fns';
import thLocale from 'date-fns/locale/th';

export default class ThaiDateFnsUtils extends DateFnsUtils {
    constructor() {
        super({ locale: thLocale });
    }

    getYearText(date) {
        return (super.getYearText(date)).replace(/\d+/, (year) => parseInt(year) + 543);
    }

    getDatePickerHeaderText(date) {
        return super.getDatePickerHeaderText(date).replace(/\d+/, (year) => parseInt(year) + 543);
    }

    getCalendarHeaderText(date) {
        return super.getCalendarHeaderText(date).replace(/\d+/, (year) => parseInt(year) + 543);
    }
    
    // Override format to show Buddhist year for any custom formats
    format(date, formatString) {
      if (formatString === 'dd/MM/yyyy') { // Match the format used in the component
          const year = super.getYear(date);
          const thaiYear = Boolean(year) ? parseInt(year) + 543 : '';
          return super.format(date, `dd/MM/`) + thaiYear;
      }
      return super.format(date, formatString);
    }
}
